import { API_BASE_URL } from "../config";

const PLACEHOLDER_PATH = "assets/img/placeholder-trikot.jpg";

/**
 * Resolves a trikot image path to an absolute URL
 * @param {string} imagePath - The image path from the database
 * @returns {string} The resolved image path
 */
export const resolveTrikotImagePath = (imagePath) => {
  if (!imagePath) {
    return resolveTrikotImagePath(PLACEHOLDER_PATH);
  }

  if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
    return imagePath;
  }

  // Persistente Uploads (überleben Frontend-Deployments)
  if (imagePath.startsWith("uploads/trikots/")) {
    const filename = imagePath.slice("uploads/trikots/".length);
    return `${API_BASE_URL}/api/uploads/trikots/${filename}`;
  }

  // Legacy: statische Dateien im Frontend-Build / public
  const normalizedPath = imagePath.startsWith("/")
    ? imagePath.substring(1)
    : imagePath;
  const publicUrl = process.env.PUBLIC_URL || "";
  const prefix = publicUrl.endsWith("/") ? publicUrl.slice(0, -1) : publicUrl;
  return prefix ? `${prefix}/${normalizedPath}` : `/${normalizedPath}`;
};

export const PLACEHOLDER_TRIKOT_IMAGE = PLACEHOLDER_PATH;
